/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import DailyReportsService from '../../services/DailyReportsService';
import ErrorHandlerHelpers from '../../mixins/ErrorHandlerHelpers';

const SET_DAILY_VOYAGE_REPORT = 'SET_DAILY_VOYAGE_REPORT';
const CLEAR_DAILY_VOYAGE_REPORT = 'CLEAR_DAILY_VOYAGE_REPORT';

const SET_DAILY_TANK_REPORT = 'SET_DAILY_TANK_REPORT';
const CLEAR_DAILY_TANK_REPORT = 'CLEAR_DAILY_TANK_REPORT';

const state = {
  dailyVoyageReport: null,
  dailyTankReport: null,
};

const getters = {
  getDailyVoyageReport: (state) => state.dailyVoyageReport,
  getDailyTankReport: (state) => state.dailyTankReport,
};

const mutations = {
  [SET_DAILY_VOYAGE_REPORT](state, dailyVoyageReport) {
    state.dailyVoyageReport = dailyVoyageReport;
  },
  [CLEAR_DAILY_VOYAGE_REPORT](state) {
    state.dailyVoyageReport = null;
  },
  [SET_DAILY_TANK_REPORT](state, dailyTankReport) {
    state.dailyTankReport = dailyTankReport;
  },
  [CLEAR_DAILY_TANK_REPORT](state) {
    state.dailyTankReport = null;
  },
};

const actions = ({
  loadDailyVoyageReport({ state, commit }, args) {
    const { activeSiteId, date } = args;
    return DailyReportsService.getDailyVoyageReport(activeSiteId, date)
      .then((x) => x.data)
      .then((dailyVoyageReportResult) => {
        commit(SET_DAILY_VOYAGE_REPORT, dailyVoyageReportResult);
      })
      .catch((err) => ErrorHandlerHelpers.handleServiceError(err));
  },
  loadDailyTankReport({ state, commit }, args) {
    const { activeSiteId, date } = args;
    return DailyReportsService.getDailyTankReport(activeSiteId, date)
      .then((x) => x.data)
      .then((dailyTankReportResult) => {
        commit(SET_DAILY_TANK_REPORT, dailyTankReportResult);
      })
      .catch((err) => ErrorHandlerHelpers.handleServiceError(err));
  },
  getDailyVoyageReportAsExcelFile({ commit }, args) {
    const { activeSiteId, date } = args;
    return DailyReportsService.getDailyVoyageReportAsExcel(activeSiteId, date);
  },
  getDailyTankReportAsExcelFile({ commit }, args) {
    const { activeSiteId, date } = args;
    return DailyReportsService.getDailyTankReportAsExcel(activeSiteId, date);
  },
});

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
